
import { Component, Vue } from "vue-property-decorator";
import { instanceToInstance, plainToInstance } from "class-transformer";

import { kpi_settings_child_routes } from "@/router/admin/kpi";

import Preloader from "@/components/Preloader.vue";
import CWorkplacePlaceholder from "@/components/WorkplacePlaceholder.vue";

import kpiRoutes from "@/api/routes/kpi";

import KpiTemplate from "@/models/kpi/template";
import KpiSetting from "@/models/kpi/setting";
import userRoutes from "@/api/routes/users";

@Component({
  components: {
    Preloader,
    CWorkplacePlaceholder
  }
})
export default class VKpiSetting extends Vue {
  protected preload: boolean = false;

  protected templates: KpiTemplate[] = [];

  protected currentTemplate: KpiTemplate | null = null;
  protected editSetting: KpiSetting | null = null;

  private currentUser: IJWTUser | null = this.$store.state.currentUser;

  protected links = kpi_settings_child_routes.map(r => {
    return {
      title: r.meta!.name,
      to: {
        name: r.name
      }
    };
  });

  protected workplaceExist: boolean = true;

  protected watchers: Function[] = [];

  protected async created() {
    this.watchers.push(
      this.$store.watch(
        state => state.currentUser,
        currentUser => {
          this.currentUser = currentUser;
        }
      )
    );

    this.WorkplaceExist().then(
      async ({ data: res }: { data: { is_exist: boolean } }) => {
        this.workplaceExist = res.is_exist;

        if (res.is_exist) {
          await this.loadTemplates();
        }
      }
    );
  }

  protected async WorkplaceExist() {
    return this.$api.get(userRoutes.workplace_exists(this.currentUser?.id!));
  }

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected async loadTemplates() {
    this.preload = true;

    return this.$api
      .get(kpiRoutes.settings)
      .then(({ data: res }: { data: KpiTemplate[] }) => {
        this.templates = plainToInstance(KpiTemplate, res);

        this.currentTemplate = this.templates[0];
        this.editSetting = instanceToInstance(this.currentTemplate.setting!);
      })
      .finally(() => {
        this.preload = false;
      });
  }

  protected changeTemplate() {
    this.editSetting = instanceToInstance(this.currentTemplate!.setting!);
  }

  protected async updateSetting() {
    if (!this.allowWrite()) {
      return;
    }

    return this.$api
      .put(kpiRoutes.setting(this.editSetting!.id), this.editSetting)
      .then(({ data: res }: { data: KpiSetting }) => {
        this.currentTemplate!.setting = plainToInstance(KpiSetting, res);

        this.$notify({
          group: "notifications",
          type: "success",
          text: "Изменения сохранены",
          speed: 500
        });
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  protected allowWrite() {
    return this.$api.allowWrite();
  }
}
